import { provideEffects } from '@ngrx/effects';
import { CategoryVppApplicationsEffects } from './category-vpp-applications.effects';

export const provideCategoryVppApplicationsStore = () => [provideEffects([CategoryVppApplicationsEffects])];
